<template>
  <NuxtLink
    :to="
      localePath({
        name: 'products-type',
        params: { type: props.productType.attributes?.slug as string },
      })
    "
    class="relative flex h-full flex-col"
    :class="{
      'mb-[70px] laptop:mb-0': props.index !== props.totalProductTypes - 1,
    }"
  >
    <div class="relative flex max-h-[331px] items-center justify-center laptop:h-full">
      <ProductTypeAnimatedImage
        :slug="props.productType.attributes?.slug"
        v-if="animatedSlugs.includes(props.productType.attributes?.slug)"
      />
      <img
        v-else
        class="h-auto max-h-full w-full object-contain"
        :src="props.productType.attributes?.icon?.data?.attributes?.url"
        :alt="props.productType.attributes?.icon?.data?.attributes?.alternativeText || ''"
        draggable="false"
        height="331"
        width="268"
      />
      <img
        class="absolute bottom-0 left-1/2 h-[17px] w-full max-w-[230px] -translate-y-1/2 -translate-x-1/2 object-contain"
        src="/images/shadow.png"
        alt="shadow"
        draggable="false"
        height="17"
        width="230"
      />
    </div>
    <h3 class="grow-1 -order-1 mb-2 shrink-0 text-center laptop:order-2 laptop:mt-10 laptop:mb-0 laptop:min-h-[56px]">
      {{ props.productType.attributes?.name }}
    </h3>
  </NuxtLink>
</template>
<script setup lang="ts">
import { ProductTypeFragment } from "#gql";

const props = defineProps<{
  productType: ProductTypeFragment;
  totalProductTypes: number;
  index: number;
}>();

const localePath = useLocalePath();

const animatedSlugs = ["olives", "fruits", "spreads", "elies", "froyta"];
</script>
<style lang="scss" scoped></style>
